export default __webpack_public_path__ + "static/photos-828b7b9c3682dc6ae2ccf3d639b127ce.png";